const Avg1 = [
    {id: "4", value: "5週，10週"},    
    {id: "0", value: "5週，20週"},    
    {id: "1", value: "5週，20週，60週"},
    {id: "2", value: "5週，10週，20天，60週"},
    {id: "3", value: "20週，60週，120週"},
  ];  
  
  export default Avg1